<template>
  <div>
    <Modal v-model="modelShow" title="自提记录" width="800">
      <data-grid v-if="dataShow" ref="lg" :columns="cols" :pagination="false" :autoLoad="false" subListName :dataList="dataList">
        <template #default="{columns, data}">
          <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px">
            <template #option="{row,index}">
              <Button type="primary" size="small" v-show="row.attachmentDocument" @click="lookFile(row.attachmentDocument)">查看附件</Button>
            </template>
          </Table>
        </template>
      </data-grid>
      <div slot="footer">
        <Button type="primary" size="small" @click="recordColse">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="fileShow" title="附件列表" width="900">
      <data-grid ref="files" :columns="column" :pagination="false" :autoLoad="false" subListName :dataList="fileList">
        <template #default="{columns, data}">
          <Table :columns="columns" :data="fileList" border stripe size="small" style="margin:10px">
            <template #originFileName="{row}">
              <a style="padding-left:20px" @click="onDownloadFile(pltUtil.downloadUrl()+row.id)">{{row.originFileName}}</a>
            </template>
          </Table>
        </template>
      </data-grid>
      <div slot="footer">
        <Button type="primary" size="small" @click="fileColse">关闭</Button>
      </div>
      <preview-image ref="previewImageRef" />
    </Modal>
  </div>
</template>

<script>
import dataGrid from "@/components/datagrid.vue";
export default {
  components: { dataGrid },
  data() {
    return {
      modelShow: false,
      dataShow: false,
      fileShow: false,
      dataList: [],
      cols: [
        { title: "交付计划编号", key: "deliveryPlanId" },
        { title: "交付数量", key: "amount" },
        { title: "自提时间", key: "confirmTime", formatter: "date" },
        { title: "备注", key: "selfPickAckComment", width: 200 },
        { title: "操作", slot: "option", widht: 100 },
      ],
      fileList: [],
      column: [
        { title: "文件名称", slot: "originFileName", align: "center" },
        {
          title: "上传时间",
          key: "uploadTime",
          formatter: "date",
          align: "center",
        },
      ],
    };
  },
  methods: {
    onDownloadFile(url) {
      var tempwindow = window.open("_blank");
      tempwindow.location = `${url}&disposition=inline`;
    },
    openModal(data) {
      this.modelShow = true;
      if (data.body.deliveryPlanId) {
        let obj = data;
        this.getData(obj);
      } else {
        this.cols = [
          { title: "交付数量", key: "amount" },
          { title: "自提时间", key: "confirmTime", formatter: "date" },
          { title: "备注", key: "selfDeliverAckComment", width: 200 },
          { title: "操作", slot: "option", widht: 100 },
        ];
        let returnObj = data;
        this.getData(returnObj);
      }
    },
    // 查看自提记录
    getData(obj) {
      let data = obj;
      this.dataShow = false;
      this.invoke(data)
        .then((res) => {
          console.log(res);
          this.dataList = res;
          this.dataShow = true;
        })
        .catch((err) => {
          this.dataShow = true;
        });
    },
    lookFile(id) {
      this.fileShow = true;
      this.getFileList(id);
    },
    // 查看自提记录
    getFileList(id) {
      let data = {
        url: "http://MID-TECH-IMAGE/messageService/documentService/queryDocument",
        body: { id },
      };
      this.invoke(data).then((res) => {
        this.fileList = res.files;
      });
    },
    recordColse() {
      this.modelShow = false;
    },
    fileColse() {
      this.fileShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>